import { colonyAPI } from '@/api';
import * as types from './mutation-types';

export default {
  getAllActivities({ commit }) {
    commit(types.GET_ACTIVITIES_REQUEST);

    colonyAPI
      .get('activities/')
      .then(response => commit(types.GET_ACTIVITIES_SUCCESS, response.data.results))
      .catch(error => commit(types.GET_ACTIVITIES_FAILURE, error.error));
  },

  deleteActivity({ commit, dispatch }, id) {
    commit(types.DELETE_ACTIVITY_REQUEST);

    colonyAPI
      .delete(`activities/${id}/`)
      .then(() => {
        commit(types.DELETE_ACTIVITY_SUCCESS, id);
        dispatch('activities/getAllActivities', null, { root: true });
      })
      .catch(error => commit(types.DELETE_ACTIVITY_FAILURE, error));
  },

  startActivityPolling({ commit, dispatch, state }) {
    if (state.activityPollInterval) {
      dispatch('activities/stopActivityPolling', null, { root: true });
    }

    const interval = setInterval(
      () => dispatch('activities/getAllActivities', null, { root: true }),
      15000,
    );
    commit(types.START_ACTIVITY_POLLING, interval);
  },

  stopActivityPolling({ commit, state }) {
    clearInterval(state.activityPollInterval);
    commit(types.STOP_ACTIVITY_POLLING);
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/activities/actions.js